// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsApproved = exports;

export const ApprovedInhabitant = 'Approved';

export type Approved = typeof ApprovedInhabitant;

export function isApproved(v: any): v is Approved {
  return ApprovedInhabitant == v;
}

export type ApprovedSingleton = Approved;
